import { UserInfo } from '@user/userInfo.js';
import { getJSON, getWalletURL } from '../tools/basic-functions.js';

async function fetchData(jsonKey, localKey, resultsAttribute = null) {
  if (window[localKey]) {
    return window[localKey];
  }

  try {
    const jsonUrl = getWalletURL(jsonKey);
    let data = await getJSON(jsonUrl, undefined, [403]);

    if (resultsAttribute && data[resultsAttribute]) {
      data = data[resultsAttribute];
    }

    window[localKey] = data;
    return data;
  } catch (error) {
    const status = error.response ? error.response.status : 'Unknown status';
    console.error(`Error fetch: ${jsonKey} [${status}]`, error);

    if (window.Sentry) {
      window.Sentry.captureException(error);
    }
    return null;
  }
}

export async function getTournamentJson() {
  const userInfoInstance = new UserInfo();
  const isLogged = await userInfoInstance.isLoggedAsync();
  if (!isLogged) {
    return false;
  }

  const jsonKey = 'api/active-tournaments/',
    localKey = 'active-tournaments',
    dataKey = 'results';

  return fetchData(jsonKey, localKey, dataKey);
}

export async function getTournamentJsonCMS(tournamentId) {
  const jsonURL = `/${_CMS_LOCALE != '' ? _CMS_LOCALE : _CMS_LANGUAGE}/json/tournament/${tournamentId}`,
    data = await getJSON(jsonURL);
  return data;
}

export async function getLiveCasinoApi() {
  const jsonKey = `api/tables/?country=${_CMS_USERIP}`,
    localKey = 'tables-live',
    dataKey = null;

  return fetchData(jsonKey, localKey, dataKey);
}
